import React, { useState } from "react";
import _ from 'underscore';
import { CheckInPeriods, CheckInTimesSidebar } from "./components/exporter";
import Rbac from '../../../utils/Rbac';
import InboomaSubmenu from '../../components/InboomaSubmenu';
import t from '../../helpers/t';
import {createSubmenuItems} from "../../../utils/Helper";
import {Biscuit} from "../../../utils";
const uuid = _.uniqueId;

export const rbac = new Rbac({
  _rbac : {
      "admin" : {
          write : true,
      },
      "manager" : {
          write : false,
      },
      "booking-manager" : {
        write : true,
    },
      "manager-location" : {
          write : true, // But restriced via hooks/useManagerHasLocation
      },
      "user" : {
          write : false,
      },
      "garage-staff" : {
          write : false,
      }
  }
});

export const OpeningTimesPage = props => {

  const [dropdown, setDropdown] = useState({});
  const [menuTimer,setMenuTimer] = useState(10);

  // mark main menu - try til menu is finally marked
  const markMainMenu = () => {
    let mainMenu = document.getElementById('inb-main-menu');
    let sidebar = document.getElementById('inb-c-sidebar');
    if (sidebar !== undefined && sidebar != null && mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-contingents')) {
        mainMenu.querySelector('.l-contingents').classList.add('active');
        setMenuTimer(0);
    } else {
      setTimeout(function () {
        setMenuTimer(menuTimer-1);
      },500);
    }
  };

  if (menuTimer > 0) setTimeout(markMainMenu(),800);

  const submenuItems = createSubmenuItems(Biscuit.get('client.show_usage_types') === 'true'?'all_times':'opening_times');

  return (
      <>
          <div className="row" style={{maxWidth:'100%', minWidth: '100%', margin: 0}}>
              <aside id="inb-c-sidebar">
                <CheckInTimesSidebar key={uuid()} />
              </aside>
              <div
                  id="inb-c-main"
                  style={{display:'flex', flexDirection:'column', width:'100%'}}
                  className="columns">
                  {props.createAccessBar &&
                  <InboomaSubmenu
                    tabs={submenuItems}
                    smallOnlyTitle={t('all_times',null,'capital')}
                  />
                  }
                    <CheckInPeriods 
                        key={uuid()}
                        dropdown={dropdown}
                        setDropdown={setDropdown}
                    />
              </div>
          </div>
      </>
  );
};